<template>
    <confirm-modal
        title="Create Files"
        confirm-button-text="Create Files"
        @close="$emit('close')"
        @submit="$emit('create', fileTypes)"
    >
        <p>{{ confirmText }}</p>
    </confirm-modal>
</template>

<script>
import ConfirmModal from '@/components/ConfirmModal'

// Keyed by the PaygroupRun.<key>_created flag the file sets
const FILE_TYPE_LABELS = {
    verifund: 'ACH',
    asure: 'Taxes',
    kotapay: 'OBC',
}

export default {
    props: {
        // The file types to create, as PaygroupRun flag names. The All tab passes all
        // three; a single-file-type tab passes just its own.
        'fileTypes': {type: Array, required: true},
        // How many PaygroupRuns the files will be created for
        'runCount': {type: Number, default: 0},
    },
    emits: ['close', 'create'],
    components: {ConfirmModal, },
    computed: {
        confirmText() {
            const runLabel = `${this.runCount} ${this.runCount == 1 ? 'run' : 'runs'}`
            return `Create ${this.fileTypeLabel} files for ${runLabel}?`
        },
        fileTypeLabel() {
            // 'ACH', or 'ACH, Taxes and OBC' when the whole set is being created
            const labels = this.fileTypes.map(fileType => FILE_TYPE_LABELS[fileType] || fileType)
            if (labels.length < 2) {
                return labels.join('')
            }
            return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
        },
    },
}
</script>
